import BasicTour from './BasicTour';

export default BasicTour;
